module.exports = "/_next/static/images/ourPartnersLogo3-2da98fc5ba568d9860cece74862e32a2.webp";